import * as React from 'react';
import GeoJSON from 'geojson';
import { observer } from 'mobx-react';
import { LocationInfo, getMapPositionParams } from '@ixicare/resources';
import GeoMapPosition from './GeoMapPosition';
import styles from './Map.module.css';

type TMapPositionProps = {
  locationData?: LocationInfo;
  siteUuid?: string;
  isStatic: boolean;
  type?: string;
  geofence?: GeoJSON.Feature<GeoJSON.Polygon>;
  animate?: boolean;
};

const MapPosition: React.FC<TMapPositionProps> = ({ locationData, siteUuid, isStatic, type, geofence, animate }) => {
  const params = React.useMemo(() => {
    if (!locationData) {
      return;
    }
    const mapParams = getMapPositionParams(locationData, isStatic);
    // Outdoor positions carry no site of their own, but a GeoPlane's tile layer needs one.
    return 'siteId' in mapParams ? mapParams : { ...mapParams, siteUuid };
  }, [locationData, isStatic, siteUuid]);

  return (
    <div className={styles.MapWrapper}>
      <GeoMapPosition params={params} type={type} geofence={geofence} animate={animate} />
    </div>
  );
};

export default observer(MapPosition);
